/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LetterCaseConstants } from './LetterCaseConstants';
import {
    LetterCaseConstantsFromJSON,
    LetterCaseConstantsFromJSONTyped,
    LetterCaseConstantsToJSON,
} from './LetterCaseConstants';
import type { Precision } from './Precision';
import {
    PrecisionFromJSON,
    PrecisionFromJSONTyped,
    PrecisionToJSON,
} from './Precision';
import type { Range } from './Range';
import {
    RangeFromJSON,
    RangeFromJSONTyped,
    RangeToJSON,
} from './Range';

/**
 * On edit, constraints any entered value is validated against, e.g. mandatoriness, length, number precision
 * @export
 * @interface Constraint
 */
export interface Constraint {
    /**
     * Optional regex constraint, as plain Java pattern, for string properties
     * @type {string}
     * @memberof Constraint
     */
    javaRegexPattern?: string;
    /**
     * Optional regex constraint, as JavaScript pattern, for string properties
     * @type {string}
     * @memberof Constraint
     */
    javaScriptRegexPattern?: string;
    /**
     * Optional length constraint, for string properties
     * @type {number}
     * @memberof Constraint
     */
    length?: number;
    /**
     * 
     * @type {LetterCaseConstants}
     * @memberof Constraint
     */
    letterCase?: LetterCaseConstants;
    /**
     * 
     * @type {Precision}
     * @memberof Constraint
     */
    precision?: Precision;
    /**
     * 
     * @type {Range}
     * @memberof Constraint
     */
    range?: Range;
    /**
     * 
     * @type {boolean}
     * @memberof Constraint
     */
    mandatory: boolean;
}

/**
 * Check if a given object implements the Constraint interface.
 */
export function instanceOfConstraint(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mandatory" in value;

    return isInstance;
}

export function ConstraintFromJSON(json: any): Constraint {
    return ConstraintFromJSONTyped(json, false);
}

export function ConstraintFromJSONTyped(json: any, ignoreDiscriminator: boolean): Constraint {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'javaRegexPattern': !exists(json, 'javaRegexPattern') ? undefined : json['javaRegexPattern'],
        'javaScriptRegexPattern': !exists(json, 'javaScriptRegexPattern') ? undefined : json['javaScriptRegexPattern'],
        'length': !exists(json, 'length') ? undefined : json['length'],
        'letterCase': !exists(json, 'letterCase') ? undefined : LetterCaseConstantsFromJSON(json['letterCase']),
        'precision': !exists(json, 'precision') ? undefined : PrecisionFromJSON(json['precision']),
        'range': !exists(json, 'range') ? undefined : RangeFromJSON(json['range']),
        'mandatory': json['mandatory'],
    };
}

export function ConstraintToJSON(value?: Constraint | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'javaRegexPattern': value.javaRegexPattern,
        'javaScriptRegexPattern': value.javaScriptRegexPattern,
        'length': value.length,
        'letterCase': LetterCaseConstantsToJSON(value.letterCase),
        'precision': PrecisionToJSON(value.precision),
        'range': RangeToJSON(value.range),
        'mandatory': value.mandatory,
    };
}

